import {RequestsState} from './requests.model';
import {createReducer, on} from '@ngrx/store';
import {assign} from '../../../../lib/assign';
import {requestLoadComplete, requestLoadStart} from './requests.actions';

const INITIAL_STATE: RequestsState = {
    pendingRequests: 0
};

export const requestsReducer = createReducer(
    INITIAL_STATE,
    on(requestLoadStart, (state) => assign(
        state, {pendingRequests: state.pendingRequests + 1})),
    on(requestLoadComplete, (state) => assign(
        state, {pendingRequests: state.pendingRequests > 0 ? state.pendingRequests - 1 : 0}))
);